import { CollectionRepository, FirestoreQueryBuilder } from '@engineering11/web-api-firebase'
import { IJobPostUserConfig } from '@employer/app/models/job-post-user-config.model'
import { Injectable } from '@angular/core'
import { COLLECTIONS } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class JobPostUserConfigRepository extends CollectionRepository<IJobPostUserConfig> {
  protected COLLECTION: string = COLLECTIONS.JOB_POST_USER_CONFIG

  getAllForCustomer(customerKey: string) {
    const query = new FirestoreQueryBuilder<IJobPostUserConfig>()
    query.where('customerKey', '==', customerKey)
    return this.query(query.build())
  }

  // Live: a brand-new user's document is written by the backend shortly after signup, so a
  // subscriber sees it appear instead of a one-shot read missing it.
  getForCustomerUser(userId: string) {
    return this.getValueChanges(userId)
  }
}
